import React, {useState, useEffect} from 'react';
import GaugeChart from 'react-gauge-chart';
import {AppConstants, formatTime} from '../model/enums';

interface GaugeProps {
    startTime: Date; // veya Date, ihtiyacına göre
    loopCount: number;
    loopRemainingCount: number;
    loopOn: number;
    loopOff: number;
    color0: string;
    color1: string;
}

const LoopGauge: React.FC<GaugeProps> = ({startTime, loopCount, loopRemainingCount, loopOn, loopOff, color0, color1}) => {
    const _loopOn = loopOn + 1.5;
    const _loopOff = loopOff + 1.5;
    const period = _loopOn + _loopOff;
    // const periodMillis = period * 1000;
    const duration = loopCount * period;
    const elapsedTime = Math.max(
        Math.floor((Date.now() - new Date(startTime).getTime()) / 1000),
        0
    );
    const remainingTime = Math.max(
        Math.ceil(loopRemainingCount * period),
        0
    );
    const _startTime = Math.round(new Date(startTime).getTime() / 1000);
    const _loopIndex = Math.ceil((Math.round(Date.now() / 1000) - _startTime) / period) - 1;

    // const duration = period;
    const [percentage, setPercentage] = useState(0); // İbreyi 100% ile başlatıyoruz.
    const [remainingMinutes, setRemainingMinutes] = useState(0); // İbreyi 100% ile başlatıyoruz.
    const [currentValue, setCurrentValue] = useState(0);
    const [currentLoop, setCurrentLoop] = useState(_loopIndex);

    const [offState, setOffState] = useState(true);



    useEffect(() => {
        let _timeIndex = 0; // todo
        let timerInterval = AppConstants.getTimerInterval(period);
        if (currentLoop < loopCount) {
            // processler(null);
            const timer = setInterval(() => {
                // processler(timer);
                setCurrentValue((prevValue) => {
                    let _now = Math.round(Date.now() / 1000);
                    //    console.log(`currentLoop: ${currentLoop}, startTime: ${_startTime} now: ${_now}`);
                    if (prevValue < 1) {
                        // her period için gecen süreyi bul.
                        // const elapsedTime: number = (Date.now() - new Date(startTime).getTime() + periodMillis * currentLoop) / 1000; // Geçen süreyi dakika olarak al.
                        const _deltaTime = _startTime + currentLoop * period;
                        // console.log(`deltaTime: ${_deltaTime}, period: ${period}`);
                        const elapsedTime: number = Math.max(_now - _deltaTime, 0); // Geçen süreyi dakika olarak al.
                        const ratio = elapsedTime / period;
                        // console.log(`elapsedTime: ${elapsedTime}, ratio: ${ratio}`);
                        const value = 1 - Math.max(1 - ratio, 0); // Süre dolduğunda ibre sıfırlanacak.
                        // console.log(`currentLoop: ${currentLoop}, elapsedTime: ${elapsedTime}, value: ${value}`);

                        if (ratio > 1) {
                            // clearInterval(timer);
                            // setCurrentLoop((prevLoop) => prevLoop + 1); // Döngü sayısını artır
                            // return 0; // Gauge'ı sıfırla
                        }
                        _timeIndex = period * value;
                        return value;
                        // return prevValue + (1 / (duration * 1000 / 1000)); // Her saniyede 1 birim artır
                    } else {
                        //     _timeIndex = 0;
                        clearInterval(timer);
                        setCurrentLoop((prevLoop) => prevLoop + 1); // Döngü sayısını artır
                        return 0; // Gauge'ı sıfırla
                    }
                });

                if (currentValue > 0) {
                } else {

                }
                _timeIndex += timerInterval / 1000;

                //     console.log(`DEBUG: ${_timeIndex}  -- ${loopOn} ${loopOff} ${period} ${currentValue}`);
                //                setOffState(_timeIndex < loopOn);
                setOffState(!offState);



            }, timerInterval); // Her saniyede bir güncelle

            return () => clearInterval(timer); // Temizleme işlevi
        }

    }, [startTime, loopCount, loopOn, loopOff, currentLoop, period, _startTime, offState]);

    if (duration < 60) {
        return null;
    }

    return (
        <div>
            <GaugeChart
                id="gauge-chart"
                nrOfLevels={10}
                percent={currentValue}
                // colors={['#000']} // İbrede renk geçişleri
                colors={[color1, color0]} // İbrede renk geçişleri
                arcWidth={0.07}
                arcsLength={[_loopOn / period, _loopOff / period]}
                textColor="#000"
                hideText={true}
                needleColor="grey"
                needleBaseColor={offState ? "red" : "yellow"}
                // needleBaseColor="red"
                marginInPercent={0.01}
                animate={false}
            />
            <div className="loop-status-box">
                <div>Döngü aktif — dikkat: tekrar ON olacaktır.</div>
                <div>Kalan Tur: {loopRemainingCount}</div>
                <div>Geçen Süre: {formatTime(elapsedTime)}</div>
                <div>Kalan Süre: {formatTime(remainingTime)}</div>
            </div>
            <div className="text-small" style={{textAlign: 'center', marginTop: '10px'}}>
                {`${currentLoop + 1} / ${loopCount}`}
            </div>
        </div>
    );

    // return (
    //     <div>
    //       <GaugeChart
    //         id="gauge-chart1"
    //         nrOfLevels={30} // 30 seviyeli bir gauge
    //         arcsLength={[0.3, 0.5, 0.2]} // Kırmızı, Sarı, Yeşil alanlar
    //         colors={['#ff0000', '#ffcc00', '#00ff00']} // Kırmızı, Sarı, Yeşil renkler
    //         percent={percentage} // Ölçülen değer
    //         arcPadding={0.02} // Aralarındaki boşluk
    //         style={{ height: '300px' }} // Yükseklik
    //       />
    //       <div style={{ textAlign: 'center', marginTop: '10px' }}>
    //         <h3>Değer: {Math.round(percentage * 100)}</h3> {/* Değeri göster */}
    //       </div>
    //     </div>
    //   );

};

export default LoopGauge;
